<template>
	<v-container>
		<v-divider class="mb-4"></v-divider>
		<v-row class="secondary--text">
			<v-col cols="12" class="text-left">
				<h3>Profile of the {{ userData.company }}:</h3>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col cols="12" class="text-left">current round: {{userData.currentRound}}</v-col>
			<v-col cols="12" class="text-left">gameId: {{userData.gameId}}</v-col>
			<v-col cols="12" class="text-left">company: {{ userData.company }}</v-col>
			<v-col cols="12" class="text-left">email: {{ userData.email }}</v-col>
			<v-col class="text-left">
				<!--button sign Out-->
				<v-btn class="text-capitalize"
					small text 
					color="secondary" 
					@click.prevent="onLogout">
					<v-icon>mdi-logout-variant</v-icon>
					sign Out
				</v-btn>
			</v-col>
		</v-row>
		
	</v-container>
</template>
<script>

export default {
	data () {
		return {}
	},
	computed: {		
		loading () {
			return this.$store.getters.loading
		},
		company () {
			return this.$store.getters.company
		},
		userData() {
			return this.$store.getters.userData
		}
	},
	methods: {
		async onLogout() {
			try {
				await this.$store.dispatch('logoutUser')
				this.$router.replace('/')
			}
			catch (error) {
				this.$store.dispatch('setError', error.message)
			}
		}
	},
	components: {

	}
}
</script>
